export const common = {
  nav: {
    about: 'About',
    partners: 'Partners',
    practice: 'Practice Areas',
    contact: 'Contact',
    language: 'Language'
  },
  hero: {
    badge: 'Brazil & United States',
    title1: 'Regulatory Structuring',
    title2: 'Financial Markets',
    title3: 'International Expansion',
    description: 'We help businesses navigate regulatory requirements with confidence. Legal certainty, governance, and sustainable growth in regulated environments.',
    cta1: 'Get Your Strategic Action Plan',
    cta2: 'Discover How We Help'
  },
  about: {
    badge: 'WHO WE ARE',
    title: 'Strategic Legal Services',
    titleItalic: 'Between Two Markets',
    description: 'Arieira Araujo Advogados operates at the intersection of law, regulation, and business strategy. We advise companies operating or seeking to operate in regulated environments, with focus on legal certainty, governance, and sustainable international expansion.',
    approach: 'Our approach is personalized, technical, and oriented toward strategic decision-making. We help businesses build strong legal foundations for long-term growth.',
    positioning: {
      title: 'Built for Companies That Demand Excellence',
      description: 'We were structured to serve businesses that require high technical expertise, legal certainty, and international vision. Our commitment is to deliver legal solutions that not only comply with current legislation but also strengthen your business model and support long-term growth.'
    }
  },
  problems: {
    badge: 'REAL CHALLENGES, REAL SOLUTIONS',
    title: 'Problems We',
    titleItalic: 'Actually Solve',
    description: 'These are the questions keeping founders and executives up at night. We don\'t just answer them—we',
    descriptionBold: 'solve them with actionable legal strategies',
    descriptionEnd: 'that protect your business and fuel growth.',
    list: [
      {
        question: 'How do I legally structure crypto operations in Brazil without regulatory risk?',
        solution: 'We design compliant frameworks that satisfy Central Bank requirements while protecting your business model'
      },
      {
        question: 'How do I set up an MSB in the US and ensure full compliance?',
        solution: 'We handle end-to-end MSB licensing, governance policies, and regulatory compliance so you can operate with confidence'
      },
      {
        question: 'How do I expand my franchise between Brazil and the US with legal certainty?',
        solution: 'We structure cross-border franchise operations with COF, contracts, and governance that protect your brand and revenue'
      },
      {
        question: 'How do I navigate AML/CFT requirements without slowing down my business?',
        solution: 'We implement streamlined compliance programs that meet regulatory standards while maintaining operational agility'
      },
      {
        question: 'How do I structure my company for international expansion without tax or legal pitfalls?',
        solution: 'We create cross-border corporate structures that optimize governance, minimize risk, and enable sustainable growth'
      },
      {
        question: 'How do I ensure regulatory compliance becomes part of my business strategy?',
        solution: 'We help transform compliance from cost center to strategic asset—building legal foundations that support business objectives'
      }
    ],
    cta: {
      title: 'Don\'t See Your Challenge Here?',
      description: 'Every business faces unique regulatory and legal obstacles. Let\'s discuss your specific situation and design a solution that works for you.',
      button: 'Talk to Us About Your Challenge'
    }
  },
  partners: {
    badge: 'OUR PARTNERS',
    title: 'Leadership',
    titleItalic: 'That Delivers Results',
    description: 'Our partners combine deep regulatory expertise with real-world business experience. They\'ve structured complex cross-border operations, navigated high-stakes regulatory challenges, and built legal frameworks that enable sustainable growth.',
    jessyca: {
      name: 'Jessyca Arieira',
      title: 'Partner',
      badge1: 'Legal Director – ABF Rio 2021-2023',
      badge2: 'Regulatory Structuring Expert',
      description: 'Corporate attorney specializing in regulatory structuring, financial markets, crypto assets, and international expansion. Former Legal Director of the Brazilian Franchising Association – Rio de Janeiro Section (ABF Rio) for 2021-2023, the leading representative body for franchising in Brazil.',
      expertise: 'Expertise',
      expertiseList: [
        'Regulatory structuring in Brazil',
        'AML/CFT compliance programs',
        'Corporate structuring and governance',
        'Crypto asset operations',
        'Franchisor legal organization and network expansion'
      ],
      approach: 'Her work combines regulatory expertise, business vision, and hands-on experience in structuring complex operations—advising founders, executives, and boards on risk mitigation and building legally sustainable business models.',
      admission: 'Licensed to practice law in Brazil.'
    },
    juliana: {
      name: 'Juliana Araujo',
      title: 'International Strategic Counsel',
      badge1: 'Columbia Law School',
      badge2: 'Harlan Fiske Stone Scholar',
      description: 'Juliana Araujo advises clients on cross-border corporate structuring, regulatory strategy, and international expansion.',
      expertise: 'Education & Admission',
      expertiseList: [
        'LL.M., Columbia Law School (Harlan Fiske Stone Scholar)',
        'Admitted to practice law in the State of New York',
        'Licensed to practice law in Brazil'
      ],
      approach: 'Her international education and technical expertise bring a perspective aligned with global best practices in governance and corporate structuring—essential for companies operating across borders.',
      admission: 'Admitted to practice law in the State of New York. Licensed to practice law in Brazil.'
    }
  },
  practice: {
    badge: 'HOW WE HELP',
    title: 'Solutions That',
    titleItalic: 'Drive Results',
    description: 'We specialize in turning regulatory complexity into strategic advantage—helping you operate confidently in regulated markets while building sustainable competitive moats',
    areas: [
      {
        title: 'United States Structuring',
        description: 'Enter the US market with solid legal foundation and regulatory compliance',
        items: [
          'International corporate structuring that protects your assets',
          'MSB licensing and compliance for financial operations',
          'Governance frameworks that satisfy US regulators',
          'End-to-end legal support for market entry and expansion'
        ]
      },
      {
        title: 'Regulation & Financial Markets in Brazil',
        description: 'Navigate Brazil\'s regulatory landscape with confidence and competitive edge',
        items: [
          'Crypto operations structured for regulatory compliance',
          'AML/CFT programs that meet Central Bank standards',
          'Risk governance frameworks that protect your business',
          'Regulatory strategy for fintech and financial services'
        ]
      },
      {
        title: 'Franchising Brazil & USA',
        description: 'Scale your franchise network across borders with legal certainty',
        items: [
          'Franchisor structuring that enables sustainable growth',
          'COF and contracts that protect your brand and revenue',
          'Corporate governance for multi-unit operations',
          'Cross-border expansion strategies that minimize risk'
        ]
      }
    ],
    differentials: {
      title: 'What Sets Us Apart',
      list: [
        'Seamless Brazil-USA Operations',
        'Legal + Business Strategy',
        'Regulated Markets Mastery',
        'Proactive Risk Prevention',
        'White-Glove Service'
      ]
    }
  },
  leadForm: {
    badge: 'GET STARTED',
    title: 'Receive a Free',
    titleItalic: 'Preliminary Assessment',
    description: 'Share your challenge and receive a strategic analysis from our team. We\'ll identify key regulatory risks and opportunities specific to your business.',
    form: {
      name: 'Full Name',
      company: 'Company',
      interest: 'Area of Interest',
      interestPlaceholder: 'Select an area',
      interestOptions: [
        'US Structuring & MSB',
        'Crypto Regulation in Brazil',
        'Franchising Brazil-USA',
        'AML/CFT Compliance',
        'International Expansion',
        'Other'
      ],
      email: 'Email',
      whatsapp: 'WhatsApp',
      button: 'Request Free Assessment',
      privacy: 'Your information is confidential and will only be used to provide the requested assessment.',
      success: 'Assessment request received! We\'ll contact you within 24 hours.',
      error: 'Error sending request. Please try again or contact us via WhatsApp.'
    }
  },
  cta: {
    title1: 'Ready to Navigate Regulatory Complexity',
    title2: 'With Confidence?',
    description: 'Get a customized regulatory action plan for your international expansion. Let\'s discuss how we can help eliminate legal barriers and support your growth.',
    button: 'Get Your Strategic Action Plan'
  },
  footer: {
    description: 'Strategic legal services between Brazil and United States, specializing in regulatory structuring, financial markets, crypto assets, franchising, and international business operations.',
    location: 'Brazil & USA',
    quickLinks: 'QUICK LINKS',
    practiceAreas: 'PRACTICE AREAS',
    areas: [
      'Regulatory Structuring',
      'Financial Markets',
      'Crypto Assets',
      'Franchising',
      'International Expansion'
    ],
    disclaimer: 'Attorney Advertising. This website constitutes attorney advertising under the New York Rules of Professional Conduct. The information contained herein is for general informational purposes only and does not constitute legal advice. Transmission of information through this website does not create an attorney-client relationship. Prior results do not guarantee a similar outcome. Attorneys are admitted to practice only in the jurisdictions listed in their individual biographies.',
    copyright: '2024 Arieira Araujo Advogados. All rights reserved.',
    poweredBy: 'Powered by Readdy'
  }
};
